import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from 'firebase/app';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyBWIY8ekm-UZzV8k2TzeBJFq0XjuHfSDj4",
    authDomain: "chat-8520a.firebaseapp.com",
    databaseURL: "https://chat-8520a.firebaseio.com",
    projectId: "chat-8520a",
    storageBucket: "chat-8520a.appspot.com",
    messagingSenderId: "510463302204"
  };
  firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js